"use strict";

var cov_oa5t1klcy = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\usfm\\useUsfm.js";
  var hash = "4821db9d4611aa09748dc053ecb68566cb23cd67";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\usfm\\useUsfm.js",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 26
        },
        end: {
          line: 9,
          column: 36
        }
      },
      "1": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 14,
          column: 13
        }
      },
      "2": {
        start: {
          line: 12,
          column: 22
        },
        end: {
          line: 12,
          column: 61
        }
      },
      "3": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 23
        }
      },
      "4": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 16,
          column: 14
        }
      },
      "5": {
        start: {
          line: 19,
          column: 0
        },
        end: {
          line: 22,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "useUsfm",
        decl: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 6,
            column: 23
          }
        },
        loc: {
          start: {
            line: 8,
            column: 3
          },
          end: {
            line: 17,
            column: 1
          }
        },
        line: 8
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 12
          },
          end: {
            line: 11,
            column: 13
          }
        },
        loc: {
          start: {
            line: 11,
            column: 18
          },
          end: {
            line: 14,
            column: 3
          }
        },
        line: 11
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 12,
            column: 22
          },
          end: {
            line: 12,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 12,
            column: 22
          },
          end: {
            line: 12,
            column: 26
          }
        }, {
          start: {
            line: 12,
            column: 30
          },
          end: {
            line: 12,
            column: 61
          }
        }],
        line: 12
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "4821db9d4611aa09748dc053ecb68566cb23cd67"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUsfm = useUsfm;
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _deepFreeze = _interopRequireDefault(require("deep-freeze"));

var _usfmJs = _interopRequireDefault(require("usfm-js"));

function useUsfm(_ref) {
  var usfm = _ref.usfm;
  cov_oa5t1klcy.f[0]++;

  var _ref2 = (cov_oa5t1klcy.s[0]++, (0, _react.useState)()),
      _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
      json = _ref3[0],
      setJson = _ref3[1];

  cov_oa5t1klcy.s[1]++;
  (0, _react.useEffect)(function () {
    cov_oa5t1klcy.f[1]++;

    var _usfmJson = (cov_oa5t1klcy.s[2]++, (cov_oa5t1klcy.b[0][0]++, usfm) && (cov_oa5t1klcy.b[0][1]++, (0, _deepFreeze.default)(_usfmJs.default.toJSON(usfm))));

    cov_oa5t1klcy.s[3]++;
    setJson(_usfmJson);
  }, [usfm]);
  cov_oa5t1klcy.s[4]++;
  return json;
}

;
cov_oa5t1klcy.s[5]++;
useUsfm.propTypes = {
  /** The usfm string to parse */
  usfm: _propTypes.default.string.isRequired
};
var _default = useUsfm;
exports.default = _default;